import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import { useMutation } from 'react-query';

export const updateStatus = ({ data }) => {
  return axios.patch('/customer/status', data);
};

export const useUpdateStatus = ({ id, config }) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onMutate: async (updatingCustomerDetail) => {
      await queryClient.cancelQueries(['userDetail']);

      const previousDetail = queryClient.getQueryData(['userDetail']);

      queryClient.setQueryData(['userDetail'], (old) =>
        old
          ? old.map((fee) =>
              fee.id === updatingCustomerDetail.id
                ? { ...fee, ...updatingCustomerDetail.data }
                : fee
            )
          : []
      );

      return { previousDetail };
    },
    onError: (_, __, context) => {
      if (context?.previousDetail) {
        queryClient.setQueryData(['userDetail'], context.previousDetail);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['userDetail', id]);
      addNotification({
        type: 'success',
        title: 'Status Updated',
      });
    },
    ...config,
    mutationFn: updateStatus,
  });
};
